export const firebaseConfig = {
  apiKey: "AIzaSyBDhNN1oJAAfS2hcr9emupxdNSEsHVoMKU",
  authDomain: "ohgiri-c9c9.firebaseapp.com",
  databaseURL: "https://ohgiri-c9c9.firebaseio.com",
  projectId: "ohgiri-c9c9",
  storageBucket: "ohgiri-c9c9.appspot.com",
  messagingSenderId: "239970858598",
  appId: "1:239970858598:web:dc271545959b85b57b1fa7",
  databaseURL: "https://ohgiri-c9c9.firebaseio.com",
};
